import { ApiClient } from './client';

export type InvitationStatus = 'pending' | 'accepted' | 'revoked' | 'expired';

export interface Invitation {
  id: string;
  email: string;
  status: InvitationStatus;
  remindersSent: number;
  createdAt: number;
  expiresAt: number;
  acceptedAt: number | null;
}

export interface CreateInvitationsResult {
  invited: string[];
  skipped: Array<{ email: string; reason: string }>;
}

/**
 * Invitaciones de empresa. El backend resuelve la empresa según el rol:
 * - company_admin → su propia empresa (no hace falta pasar companyId).
 * - backoffice → hay que indicar companyId.
 */
export type InvitationRole = 'student' | 'company_admin';

export const invitationsAPI = {
  create: (
    emails: string[],
    companyId?: string,
    role?: InvitationRole
  ): Promise<CreateInvitationsResult> =>
    ApiClient.post<CreateInvitationsResult>('/invitations', {
      emails,
      ...(companyId ? { companyId } : {}),
      ...(role ? { role } : {}),
    }),

  list: (companyId?: string): Promise<Invitation[]> =>
    ApiClient.get<Invitation[]>(
      companyId ? `/invitations?companyId=${encodeURIComponent(companyId)}` : '/invitations'
    ),

  resend: (id: string): Promise<{ success: boolean }> =>
    ApiClient.post<{ success: boolean }>(`/invitations/${id}/resend`, {}),

  revoke: (id: string): Promise<{ success: boolean }> =>
    ApiClient.post<{ success: boolean }>(`/invitations/${id}/revoke`, {}),
};
